// Comprehensive streaming provider mapping and management
// Maps TMDB provider IDs to service information with proper logos

// Priority order for streaming services (will appear at top)
export const PRIORITY_SERVICES = [
  'tmdb_netflix',
  'tmdb_amazon_prime',
  'tmdb_shudder', 
  'tmdb_disney_plus',
  'tmdb_hbo_max',
  'tmdb_max',
  'tmdb_peacock',
  'tmdb_paramount_plus',
  'tmdb_kanopy',
  'tmdb_criterion',
  'tmdb_amazon_video'
];

export const TMDB_PROVIDER_MAPPING = {
  // Priority Major US Streaming Services (using unique IDs to avoid conflicts)
  8: { id: 'tmdb_netflix', name: 'Netflix', logo: 'https://image.tmdb.org/t/p/original/pbpMk2JmcoNnQwx5JGpXngfoWtp.jpg', color: 'bg-red-600', priority: 1 },
  9: { id: 'tmdb_amazon_prime', name: 'Amazon Prime Video', logo: 'https://image.tmdb.org/t/p/original/68MNrwlkpF7WnmNPXLah69CR5cb.jpg', color: 'bg-blue-600', priority: 2 },
  613: { id: 'tmdb_shudder', name: 'Shudder', logo: 'https://image.tmdb.org/t/p/original/5VISkzLZOA1UpzAdVlRPtBXpjI.jpg', color: 'bg-red-900', priority: 3 },
  337: { id: 'tmdb_disney_plus', name: 'Disney Plus', logo: 'https://image.tmdb.org/t/p/original/7rwgEs15tFwyR9NPQ5vpzxTj19Q.jpg', color: 'bg-blue-800', priority: 4 },
  384: { id: 'tmdb_hbo_max', name: 'HBO Max', logo: 'https://image.tmdb.org/t/p/original/Ajqyt5aNxNGjmF9uOfxArGrdf3X.jpg', color: 'bg-purple-700', priority: 5 },
  1899: { id: 'tmdb_max', name: 'Max', logo: 'https://image.tmdb.org/t/p/original/Ajqyt5aNxNGjmF9uOfxArGrdf3X.jpg', color: 'bg-purple-700', priority: 5 },
  386: { id: 'tmdb_peacock', name: 'Peacock', logo: 'https://image.tmdb.org/t/p/original/xTVM8uXT9QocigQ08cLMNECZcQB.jpg', color: 'bg-purple-600', priority: 6 },
  531: { id: 'tmdb_paramount_plus', name: 'Paramount+', logo: 'https://image.tmdb.org/t/p/original/h5DcR0J2EESLitnhR8xLG1QymTE.jpg', color: 'bg-blue-500', priority: 7 },
  258: { id: 'tmdb_kanopy', name: 'Kanopy', logo: 'https://image.tmdb.org/t/p/original/sVBEF7q7LqjHAWSnKwDbzmr2EMY.jpg', color: 'bg-yellow-600', priority: 8 },
  618: { id: 'tmdb_criterion', name: 'Criterion Channel', logo: 'https://image.tmdb.org/t/p/original/da3jxo6RdnZZweAgdx4R9YNqHFj.jpg', color: 'bg-black', priority: 9 },
  10: { id: 'tmdb_amazon_video', name: 'Amazon Video', logo: 'https://image.tmdb.org/t/p/original/68MNrwlkpF7WnmNPXLah69CR5cb.jpg', color: 'bg-orange-600', priority: 10 },
  
  // Other Major Services
  15: { id: 'tmdb_hulu', name: 'Hulu', logo: 'https://image.tmdb.org/t/p/original/pqUTCoBcQAGyM93Z515dLovOAKe.jpg', color: 'bg-green-600' },
  350: { id: 'tmdb_apple_tv', name: 'Apple TV+', logo: 'https://image.tmdb.org/t/p/original/2E03IAZsX4ZaUqM7tXlctEPMGWS.jpg', color: 'bg-gray-800' },
  37: { id: 'tmdb_showtime', name: 'Showtime', logo: 'https://image.tmdb.org/t/p/original/SvvG9ZIdrjkqLnkTLDelgPEXvP.jpg', color: 'bg-red-800' },
  43: { id: 'tmdb_starz', name: 'Starz', logo: 'https://image.tmdb.org/t/p/original/5L8VQcCEDC9bD7gpuMWKJnTRz9P.jpg', color: 'bg-black' },
  
  // Digital Purchase/Rental
  2: { id: 'tmdb_apple_itunes', name: 'Apple iTunes', logo: '🍎', color: 'bg-gray-700' },
  3: { id: 'tmdb_google_play', name: 'Google Play Movies', logo: '🎞️', color: 'bg-blue-500' },
  68: { id: 'tmdb_microsoft', name: 'Microsoft Store', logo: '🪟', color: 'bg-blue-600' },
  7: { id: 'tmdb_vudu', name: 'Vudu', logo: '🎬', color: 'bg-blue-700' },
  
  // Free Services
  73: { id: 'tmdb_tubi', name: 'Tubi TV', logo: '🆓', color: 'bg-green-700' },
  207: { id: 'tmdb_crackle', name: 'Crackle', logo: '🆓', color: 'bg-orange-700' },
  257: { id: 'tmdb_pluto', name: 'Pluto TV', logo: '🪐', color: 'bg-purple-500' },
  
  // Additional Services
  157: { id: 'tmdb_hbo_now', name: 'HBO Now', logo: '👑', color: 'bg-purple-800' },
  387: { id: 'tmdb_discovery', name: 'Discovery+', logo: '🔍', color: 'bg-blue-400' },
  
  // International Services (common ones)
  119: { id: 'tmdb_amazon_prime_uk', name: 'Amazon Prime Video (UK)', logo: '📺', color: 'bg-blue-600' },
  146: { id: 'tmdb_netflix_kids', name: 'Netflix Kids', logo: '👶', color: 'bg-red-400' },
  
  // Live TV Services
  39: { id: 'tmdb_youtube_tv', name: 'YouTube TV', logo: '📺', color: 'bg-red-500' },
  358: { id: 'tmdb_fubotv', name: 'fuboTV', logo: '⚽', color: 'bg-green-500' },
  
  // Legacy/Other
  26: { id: 'tmdb_epix', name: 'Epix', logo: '🎬', color: 'bg-yellow-600' },
  1796: { id: 'tmdb_netflix_basic', name: 'Netflix basic with Ads', logo: '🎬', color: 'bg-red-500' }
};

// Fallback for unknown providers
const createFallbackProvider = (tmdbProvider) => ({
  id: `tmdb_${tmdbProvider.provider_id}`,
  name: tmdbProvider.provider_name,
  logo: getProviderLogo(tmdbProvider.provider_name),
  color: getProviderColor(tmdbProvider.provider_name)
});

// Smart logo assignment based on provider name
const getProviderLogo = (providerName) => {
  const name = providerName.toLowerCase();
  
  if (name.includes('netflix')) return '🎬';
  if (name.includes('amazon') || name.includes('prime')) return '📺';
  if (name.includes('disney')) return '🏰';
  if (name.includes('hulu')) return '🎭';
  if (name.includes('hbo') || name.includes('max')) return '👑';
  if (name.includes('apple')) return '🍎';
  if (name.includes('paramount')) return '⭐';
  if (name.includes('peacock')) return '🦚';
  if (name.includes('showtime')) return '🎪';
  if (name.includes('starz')) return '✨';
  if (name.includes('youtube')) return '📺';
  if (name.includes('google')) return '🎞️';
  if (name.includes('microsoft')) return '🪟';
  if (name.includes('vudu')) return '🎬';
  if (name.includes('tubi') || name.includes('free')) return '🆓';
  if (name.includes('crackle')) return '🆓';
  if (name.includes('pluto')) return '🪐';
  if (name.includes('discovery')) return '🔍';
  if (name.includes('criterion')) return '🎭';
  if (name.includes('shudder')) return '🧟';
  if (name.includes('epix')) return '🎬';
  if (name.includes('fubotv') || name.includes('fubo')) return '⚽';
  
  // Default streaming icon
  return '📱';
};

// Smart color assignment based on provider name
const getProviderColor = (providerName) => {
  const name = providerName.toLowerCase();
  
  if (name.includes('netflix')) return 'bg-red-600';
  if (name.includes('amazon') || name.includes('prime')) return 'bg-blue-600';
  if (name.includes('disney')) return 'bg-blue-800';
  if (name.includes('hulu')) return 'bg-green-600';
  if (name.includes('hbo') || name.includes('max')) return 'bg-purple-700';
  if (name.includes('apple')) return 'bg-gray-800';
  if (name.includes('paramount')) return 'bg-blue-500';
  if (name.includes('peacock')) return 'bg-purple-600';
  if (name.includes('showtime')) return 'bg-red-800';
  if (name.includes('starz')) return 'bg-black';
  if (name.includes('youtube')) return 'bg-red-500';
  if (name.includes('google')) return 'bg-blue-500';
  if (name.includes('microsoft')) return 'bg-blue-600';
  if (name.includes('vudu')) return 'bg-blue-700';
  if (name.includes('tubi') || name.includes('free')) return 'bg-green-700';
  if (name.includes('crackle')) return 'bg-orange-700';
  if (name.includes('pluto')) return 'bg-purple-500';
  if (name.includes('discovery')) return 'bg-blue-400';
  if (name.includes('criterion')) return 'bg-black';
  if (name.includes('shudder')) return 'bg-red-900';
  if (name.includes('epix')) return 'bg-yellow-600';
  if (name.includes('fubotv') || name.includes('fubo')) return 'bg-green-500';
  
  // Default color
  return 'bg-gray-600';
};

// Convert TMDB providers to our format
export const convertTMDBProvidersToServices = (tmdbProviders) => {
  const services = [];
  const processedIds = new Set();
  
  // Process all provider types
  ['flatrate', 'buy', 'rent'].forEach(type => {
    if (tmdbProviders[type]) {
      tmdbProviders[type].forEach(provider => {
        const mappedProvider = TMDB_PROVIDER_MAPPING[provider.provider_id];
        
        let serviceData;
        if (mappedProvider) {
          serviceData = mappedProvider;
        } else {
          // Create fallback for unknown provider
          serviceData = createFallbackProvider(provider);
        }
        
        // Avoid duplicates
        if (!processedIds.has(serviceData.id)) {
          services.push({
            ...serviceData,
            tmdbId: provider.provider_id,
            tmdbName: provider.provider_name,
            type: type, // flatrate, buy, rent
            priority: serviceData.priority || 999
          });
          processedIds.add(serviceData.id);
        }
      });
    }
  });
  
  return services;
};

// Get enhanced streaming services list (prioritizes TMDB over defaults)
export const getEnhancedStreamingServices = (tmdbProviders = null, defaultServices = []) => {
  let enhancedServices = [];
  
  if (tmdbProviders) {
    // Start with TMDB services (these have priority and proper logos)
    const tmdbServices = convertTMDBProvidersToServices(tmdbProviders);
    const tmdbServiceMap = new Map();
    
    // Create a map of TMDB services for efficient lookup
    tmdbServices.forEach(tmdbService => {
      tmdbServiceMap.set(tmdbService.id, {
        id: tmdbService.id,
        name: tmdbService.name,
        color: tmdbService.color,
        icon: tmdbService.logo,
        tmdbId: tmdbService.tmdbId,
        fromTMDB: true,
        priority: tmdbService.priority || 999
      });
    });
    
    // Add non-conflicting default services
    defaultServices.forEach(defaultService => {
      // Check if this default service conflicts with TMDB services
      const hasConflict = tmdbServices.some(tmdbService => 
        // Check for ID conflicts or similar names
        tmdbService.id === defaultService.id ||
        tmdbService.name.toLowerCase().includes(defaultService.name.toLowerCase()) ||
        defaultService.name.toLowerCase().includes(tmdbService.name.toLowerCase())
      );
      
      if (!hasConflict) {
        tmdbServiceMap.set(defaultService.id, {
          ...defaultService,
          priority: defaultService.priority || 999,
          fromTMDB: false
        });
      }
    });
    
    enhancedServices = Array.from(tmdbServiceMap.values());
  } else {
    // No TMDB data, use defaults with priority assignment
    enhancedServices = defaultServices.map(service => ({
      ...service,
      priority: service.priority || 999,
      fromTMDB: false
    }));
  }
  
  // Sort services: priority services first (by priority number), then others alphabetically
  return enhancedServices.sort((a, b) => {
    const aPriority = a.priority || 999;
    const bPriority = b.priority || 999;
    
    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }
    
    // If same priority, sort alphabetically
    return a.name.localeCompare(b.name);
  });
};
